// extracted by mini-css-extract-plugin
export default {"empty-wrap":"Vo42e_empty-wrap","empty-icon":"rzebG_empty-icon","empty-text":"qDLWg_empty-text"};